/* MNLY homepage behaviors. Pairs with mnly-home.css / mnly-v2.css.
   All markup is server-rendered by the mnly-* sections; this file only
   attaches behavior. Every binding is guarded so sections can be
   reordered or removed in the theme editor without errors. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- Scroll reveal ----
       Trigger lives here; the animation may not. When mnly-smooth.js has
       Motion available it publishes window.MNLYReveal and takes over the
       entrance (adding .in itself) so items can stagger. Without it the
       plain .in class + CSS transition is the fallback. Never both. */
    var reveal = function (el) {
      if (window.MNLYReveal) window.MNLYReveal(el);
      else el.classList.add('in');
    };
    var revealIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            reveal(e.target);
            revealIo.unobserve(e.target);
          }
        });
      },
      /* -10% bottom, not -40px: at -40px an element began its entrance with
         barely a sliver on screen, so most of the animation played where the
         eye wasn't and the user only ever caught the tail. Threshold stays
         0.12 so short elements (the ~20px compliance line under biomarkers)
         still trip. */
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );
    /* Items inside a horizontal rail reveal with the rail, not individually:
       their own intersection depends on scrollLeft, and a fast flick can jump
       a card past the observer between frames so it never fires and stays at
       opacity 0 forever. */
    function xRail(el) {
      var p = el.parentElement;
      while (p && p !== document.body) {
        var ox = getComputedStyle(p).overflowX;
        if ((ox === 'auto' || ox === 'scroll') && p.scrollWidth > p.clientWidth + 8) return p;
        p = p.parentElement;
      }
      return null;
    }
    var railGroups = new Map();
    document.querySelectorAll('.v2-page [data-reveal]').forEach(function (el) {
      var rail = xRail(el);
      if (rail) {
        if (!railGroups.has(rail)) railGroups.set(rail, []);
        railGroups.get(rail).push(el);
      } else {
        revealIo.observe(el);
      }
    });
    railGroups.forEach(function (els, rail) {
      var railIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            els.forEach(reveal);
            railIo.disconnect();
          });
        },
        { threshold: 0.05 }
      );
      railIo.observe(rail);
    });

    /* ---- Hero chips: scroll parallax ----
       The m-drift keyframe animates transform, so parallax is handed to it as
       --para px (see mnly-home.css) rather than a competing transform. The
       desktop scroller is .page-wrapper, not window, so pick whichever element
       actually scrolls. */
    if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      document.querySelectorAll('.m-hero-visual').forEach(function (visual) {
        var chips = [
          [visual.querySelector('.m-float-a'), -0.06],
          [visual.querySelector('.m-float-b'), 0.04],
          [visual.querySelector('.m-float-c'), -0.03]
        ].filter(function (c) { return c[0]; });
        if (!chips.length) return;

        var pw = document.querySelector('.page-wrapper');
        var scroller = pw && pw.scrollHeight > pw.clientHeight + 1 ? pw : null;
        var MAX = 32;
        var queued = false;

        function paint() {
          queued = false;
          var y = scroller ? scroller.scrollTop : window.pageYOffset;
          chips.forEach(function (c) {
            var px = Math.max(-MAX, Math.min(MAX, y * c[1]));
            c[0].style.setProperty('--para', px.toFixed(2) + 'px');
          });
        }
        function onScroll() {
          if (queued) return;
          queued = true;
          requestAnimationFrame(paint);
        }
        (scroller || window).addEventListener('scroll', onScroll, { passive: true });
        paint();
      });
    }

    /* ---- Big stat counters ---- */
    var statIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          var to = parseFloat(el.dataset.to || '0');
          var fixed = parseInt(el.dataset.fixed || '0', 10);
          var t0 = performance.now();
          var dur = 1800;
          function tick(t) {
            var k = Math.min(1, (t - t0) / dur);
            var eased = 1 - Math.pow(1 - k, 3);
            el.textContent = (to * eased).toFixed(fixed);
            if (k < 1) requestAnimationFrame(tick);
            else el.textContent = to.toFixed(fixed);
          }
          requestAnimationFrame(tick);
          statIo.unobserve(el);
        });
      },
      { threshold: 0.3 }
    );
    document.querySelectorAll('.vs-stat-num[data-to]').forEach(function (el) {
      statIo.observe(el);
    });

    /* ---- Horizontal rails (voices + advisors): arrows + progress ---- */
    function bindRail(root, railSel, trackSel, fillSel, prevSel, nextSel, gap, multiplier) {
      var rail = root.querySelector(railSel);
      var fill = root.querySelector(fillSel);
      if (!rail) return;
      var track = trackSel ? root.querySelector(trackSel) : rail;
      function step() {
        var card = track && track.firstElementChild;
        return card ? card.getBoundingClientRect().width + gap : 320;
      }
      function update() {
        if (!fill) return;
        var max = rail.scrollWidth - rail.clientWidth;
        fill.style.width = max > 0 ? (rail.scrollLeft / max) * 100 + '%' : '0%';
      }
      var prev = root.querySelector(prevSel);
      var next = root.querySelector(nextSel);
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * multiplier, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * multiplier, behavior: 'smooth' }); });
      rail.addEventListener('scroll', update, { passive: true });
      update();
    }
    document.querySelectorAll('.m-voices').forEach(function (root) {
      bindRail(root, '.m-vc-rail', '.voices-track', '#vcFill, .m-vc-progress .m-adv-progress-fill', '.m-vc-prev', '.m-vc-next', 14, 2);
    });
    document.querySelectorAll('.m-adv').forEach(function (root) {
      bindRail(root, '.m-adv-rail', '.m-adv-track', '.m-adv-progress-fill', '.m-adv-prev', '.m-adv-next', 20, 1);
    });

    /* ---- Voices: autoplay in view, tap to unmute ---- */
    var canAutoplay = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (canAutoplay) {
      var videoIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting && e.intersectionRatio > 0.5) { if (!v.dataset.userPaused) v.play().catch(function () {}); }
            else v.pause();
          });
        },
        { threshold: [0, 0.5, 1] }
      );
      document.querySelectorAll('.voices-media').forEach(function (v) { videoIo.observe(v); });
    }
    /* Sound is exclusive: unmuting a card mutes the others. Icons and
       aria state track the video, and the card body is a big sound target. */
    function setSound(card, on) {
      var v = card.querySelector('video');
      var b = card.querySelector('[data-voice-sound]');
      if (!v) return;
      v.muted = !on;
      card.classList.toggle('is-sound', on);
      if (b) {
        b.setAttribute('aria-pressed', String(on));
        b.setAttribute('aria-label', (on ? 'Mute ' : 'Unmute ') + (card.querySelector('.voices-caption') || {}).textContent);
      }
      if (on) v.play().catch(function () {});
    }
    document.querySelectorAll('.voices-card').forEach(function (card) {
      var v = card.querySelector('video');
      if (!v) return;
      function toggleSound() {
        var on = v.muted;
        if (on) {
          document.querySelectorAll('.voices-card.is-sound').forEach(function (other) {
            if (other !== card) setSound(other, false);
          });
        }
        setSound(card, on);
      }
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-voice-play]')) return;
        toggleSound();
      });
      var play = card.querySelector('[data-voice-play]');
      if (play) play.addEventListener('click', function (e) {
        e.stopPropagation();
        var pausing = !v.paused;
        if (pausing) { v.pause(); v.dataset.userPaused = '1'; }
        else { delete v.dataset.userPaused; v.play().catch(function () {}); }
        card.classList.toggle('is-paused', pausing);
        play.setAttribute('aria-label', (pausing ? 'Play ' : 'Pause ') + (card.querySelector('.voices-caption') || {}).textContent);
        play.setAttribute('aria-pressed', String(pausing));
      });
      v.addEventListener('pause', function () { card.classList.add('is-paused'); });
      v.addEventListener('play', function () { card.classList.remove('is-paused'); });
    });
  });
})();
